import React, { useEffect, useRef, useState } from 'react'

const RASTER_RE = /\.(jpe?g|png)(\?.*)?$/i;

const toWebp = (src) =>
    src.replace(RASTER_RE, (match, ext, query) => `.webp${query || ''}`);

/**
 * Drop-in replacement for <img>. It points the <img> src directly at the
 * .webp version of the image, and automatically falls back to the original
 * .jpg/.png if that .webp is missing/broken.
 *
 * .svg, .gif, .mp4 and already-.webp URLs are left untouched.
 * All standard <img> props (className, alt, title, loading, style, onClick,
 * onError, ...) are forwarded.
 */
const SmartImage = ({ src, onError, ...rest }) => {
    const canWebp = typeof src === 'string' && RASTER_RE.test(src);
    const [currentSrc, setCurrentSrc] = useState(canWebp ? toWebp(src) : src);
    const triedFallback = useRef(false);

    useEffect(() => {
        triedFallback.current = false;
        setCurrentSrc(canWebp ? toWebp(src) : src);
    }, [src, canWebp]);

    const handleError = (event) => {
        if (canWebp && !triedFallback.current && currentSrc !== src) {
            triedFallback.current = true;
            setCurrentSrc(src);
            return;
        }
        if (onError) {
            onError(event);
        }
    };

    return <img {...rest} src={currentSrc} onError={handleError} />;
};

export default SmartImage
